export enum DeployStatusForTable {
  Draft = 'Draft',
  Deployed = 'Deployed',
  Pending = 'Pending',
}
